import { render, staticRenderFns } from "./VentilatorModal.vue?vue&type=template&id=8d291460&scoped=true&"
import script from "./VentilatorModal.vue?vue&type=script&lang=js&"
export * from "./VentilatorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d291460",
  null
  
)

export default component.exports